export const NOT_AUTHORIZED = 'ERROR/NOT_AUTHORIZED';

export const notAuthorized = failedAction => ({
  type: NOT_AUTHORIZED,
  failedAction,
});
